"use client"

import type { ICompetition } from "src/lib/types/Filmnytt"

import styles from "./CompetitionForm.module.css";
import { useRef, useState } from "react";
import classNames from "classnames";

type CompetitionFormProps = ICompetition & {
    className?: string;
};

export default function CompetitionForm({ competitionOptions, competitionQuestion, competitionTitle, competitionShowFieldPhone, className }: CompetitionFormProps) {
    const formRef = useRef<HTMLFormElement>(null);
    const [submitting, setSubmitting] = useState(false);
    const [message, setMessage] = useState<string | null>(null);

    if (!competitionTitle) {
        return null;
    }

    console.log("Trondtest. competitionShowFieldPhone: " + competitionShowFieldPhone);

    async function handleCompetitionSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();
        const form = e.currentTarget;

        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }

        setSubmitting(true);
        setMessage(null);

        const formData = new FormData(form);
        const name = formData.get("name")?.toString().trim() ?? "";
        const email = formData.get("email")?.toString().trim().toLowerCase() ?? "";
        const newsletter = !!formData.get("newsletter");
        const phone = formData.get("phone")?.toString().trim().replaceAll(" ", "") ?? "";
        const answer = formData.get("competitionAnswer")?.toString() ?? "";

        const baseUrl = "https://competitionapi.azurewebsites.net/api/competition/submit";

        // local test
        // const baseUrl = "http://localhost:7152/api/competition/submit";

        try {
            const res = await fetch(baseUrl, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    formKey: competitionTitle, // unik nøkkel
                    name,
                    email,
                    phone,
                    newsletter,
                    payload: { answer, timestamp: new Date().toISOString() },
                }),
            });

            if (res.ok) {
                setMessage("✅ Svar sendt inn! Lykke til 🍀");
                form.reset();
            } else {
                const data = await res.json().catch(() => ({}));
                if (data.error === "already_submitted" || data.error === "rate_limited") {
                    setMessage("⚠️ Du har allerede deltatt i denne konkurransen.");
                } else if (data.error === "missing_fields") {
                    setMessage("⚠️ Du må fylle ut alle feltene.");
                } else {
                    setMessage("❌ Noe gikk galt. Prøv igjen senere.");
                }
            }
        } catch (err) {
            console.error(err);
            setMessage("❌ Nettverksfeil. Prøv igjen senere.");
        } finally {
            setSubmitting(false);
        }
    }

    return <form className={classNames(styles.SCompForm, className)} onSubmit={handleCompetitionSubmit}>
        <h2>{competitionTitle}</h2>
        <p>{competitionQuestion}</p>

        {(competitionOptions ?? []).map((option, i) => (
            <label key={i} className={styles.SCompLabelWithInput} style={{ marginBottom: "0.5rem" }}>
                <input type="radio" className={styles.SCompRadioButton} name="competitionAnswer" value={option ?? ""} required /> {option}
            </label>
        ))}

        <div className={styles.SCompOneInput}>
            <label className={styles.SCompLabel}>Navn:</label>
            <input className={styles.SCompInputText} type="text" name="name" required />
        </div>
        <div className={styles.SCompOneInput}>
            <label className={styles.SCompLabel}>E-post:</label>
            <input className={styles.SCompInputText} type="email" name="email" required />
        </div>

        {competitionShowFieldPhone &&
            <div className={styles.SCompOneInput}>
                <label className={styles.SCompLabel}>Mobilnr:</label>
                <input className={styles.SCompInputText} type="tel" name="phone" pattern="[0-9\s]+" required />
            </div>
        }

        <div className={styles.SCompOneInput}>
            <label className={styles.SCompLabelWithInput}>
                <input type="checkbox" className={styles.SCompCheckbox} required /> Jeg godtar{" "}
                <a href="https://forms.filmweb.no/form/displayform?id=68" className={styles.SCompLink} target="_blank" rel="noopener noreferrer">
                    personvernerklæringen
                </a>
            </label>
        </div>
        <div className={styles.SCompOneInput}>
            <label className={styles.SCompLabelWithInput}>
                <input type="checkbox" className={styles.SCompCheckbox} name="newsletter" />
                <div>
                    Jeg ønsker å motta nyhetsbrev
                    (<a href="https://forms.filmweb.no/form/displayform?id=20" className={styles.SCompLink} target="_blank" rel="noopener noreferrer">personvernerklæring</a>).
                </div>
            </label>
        </div>

        <button type="submit" className={styles.SCompButton} disabled={submitting}>
            {submitting ? "Sender..." : "Send inn"}
        </button>

        {message && <p className={styles.SCompMessage}>{message}</p>}
    </form>;
}
